// 27 Dec 2019 Repository Changed
import Vue from 'vue'
import qs from 'qs'
import $ from 'jquery'
import Cookies from 'js-cookie';
// import FileSaver from 'file-saver';

// const domain = "https://test.ftech.com.hk/biotrue/rest";
// const domain = "http://localhost/biotrue/rest";
// const domain = "http://localhost:8888/biotrue/rest";
const domain = process.env.DOMAIN;
export { domain };

export default class API {

  constructor() {
    this.domain = domain;
    this.token = Cookies.get('token');

    // this.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsb2NhbGhvc3QiLCJpYXQiOjE1MzIwMTcwMzIsImV4cCI6MTUzMjEwMzQzMiwidXNlcklEIjoiNDQiLCJ1c2VyQ29kZSI6IlU2NjY2IiwidXNlcm5hbWUiOiJyb2JpbkBnbWFpbC5jb20iLCJ1c2VyVHlwZSI6IkEiLCJ1c2VyRW50aXR5SUQiOiI0MSIsIkEiOnsiSUQiOiI0MSIsImFnZW50Q29kZSI6IjAxMDAwMDAwOSIsImFnZW50VGVhbSI6IjIiLCJwb3NpdGlvbiI6Ik0iLCJhZ2VudFR5cGUiOiJNIn0sInJvbGVzIjpbImFnZW50Il0sInBlcm1pc3Npb25zIjpbXSwibGFuZ3VhZ2UiOiIifQ.vksySyLFyrSDhexKwh-GQwh32hnEZhe-PvgSd8oEX-M';
    var parseType = Object.freeze({
      json: 0,
      empty: 1,
      download: 2,
    });
    this.ParseTypeEnum = parseType;
  }

  generatePath(dest) {
    // console.log("Destination: " + this.domain + dest);
    return this.domain + dest;
  }

  updateToken(newToken) {
    this.token = newToken;
    console.log(this.token);
  }

  // takes a {} object and returns a FormData object
  objectToFormData(model, form, namespace) {
    let formData = form || new FormData();
    let formKey;
    for (let propertyName in model) {
      if (!model.hasOwnProperty(propertyName) || !model[propertyName]) continue;
      let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
      if (model[propertyName] instanceof Date)
        formData.append(formKey, model[propertyName].toISOString());
      else if (model[propertyName] instanceof Array) {
        model[propertyName].forEach((element, index) => {
          const tempFormKey = `${formKey}[${index}]`;
          console.debug("line37 : " + `${formKey}[${index}]`);
          this.objectToFormData(element, formData, tempFormKey);
        });
      } else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File)) {
        console.debug(`this.objectToFormData(${model[propertyName]}, formData, ${formKey})`);
        this.objectToFormData(model[propertyName], formData, formKey);
      } else
        formData.append(formKey, model[propertyName].toString());
    }
    return formData;
  };

  buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
      Object.keys(data).forEach(key => {
        this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else {
      const value = data == null ? '' : data;

      formData.append(parentKey, value);
    }
  }

  jsonToFormData(data) {
    const formData = new FormData();
    this.buildFormData(formData, data);
    return formData;
  }

  get(dest, parameters = [], success, error, parseType = this.ParseTypeEnum.json, responseType = {}) {

    if (!(parameters instanceof Array) && Object.keys(parameters).length != 0) {
      var params = "?";
      params += qs.stringify(parameters);
    } else if (parameters.length > 0) {
      var params = "?";
      for (var i = 0; i < parameters.length; i++) {
        var p = parameters[i];
        if (i == 0) {
          params += p.key + "=" + p.value;
        } else {
          params += '&' + p.key + "=" + p.value;
        }
      }
    } else {
      var params = ""
    }

    let path = this.generatePath(dest + params);

    let headers = {
      headers: {
        // "Authorization": "Bearer " + this.token
        // "Authorization": `Bearer ${Cookies.get('token')}`
        "Authorization": this.token
      }
    };
    // console.debug(Vue.axios.defaults);
    // return

    Vue.axios
      .get(path, responseType)
      .then((response) => {
        console.debug("Success response", path);
        console.debug("Status code", response.data.status);

        switch (parseType) {
          case this.ParseTypeEnum.json:
            let status = response.data.status;
            switch (status) {
              case 403:
              case 401:
                Cookies.remove('token');
                window.location = process.env.REDIRECT_PATH;
                break;
              case 200:
                success(response.data);
                break;
              default:
                alert(`Error (${status}): ${response.data.message}`);
                error(response.data);
                break;
            }
            break;
          case this.ParseTypeEnum.empty:
            console.debug(response);
            success(response);
            break;
        }
      })
      .catch((err) => {
        console.error("Error response from " + path);
        console.error("Status code: " + err);
        error(err);
      })
  }

  post(dest, parameters = {}, success, error, parseType = this.ParseTypeEnum.json) {
    let headers = {
      headers: {
        // "Authorization": "Bearer " + Vue.axios.defaults.headers.common['Authorization'],
        // "Authorization": "Bearer " + this.token,
        // 'Content-Type': 'multipart/form-data'
        // "Content-Type": "application/FormData",
        // "Cache-Control": "no-cache"
        "Authorization": this.token

      }
    };

    let path = this.generatePath(dest);

    let params = this.jsonToFormData(parameters);

    console.info("POST request with body: " + JSON.stringify(params));


    Vue.axios
      .post(path, params)
      .then((response) => {
        console.log("Success response from " + path);
        console.log("Status code: " + response.data.status);

        let status = response.data.status;
        switch (status) {
          case 403:
          case 401:
            Cookies.remove('token');
            window.location = process.env.REDIRECT_PATH;
            // window.location = "https://test.ftech.com.hk/haitong-web";

            break;
          case 200:
            success(response.data);
            break;
          default:
            alert(`Error (${status}): ${response.data.message}`);
            error(response.data);
            break;
        }
      })
      .catch((err) => {
        console.error("Error response from " + path);
        console.error("Status code: " + err);
        error(err);
      })
  }


  filePost(dest, parameters = {}, success, error, parseType = this.ParseTypeEnum.json) {
    let headers = {
      headers: {
        // "Authorization": "Bearer " + this.token,
        "Content-Type": 'multipart/form-data',
        "Authorization": this.token
      }
    };

    let path = this.generatePath(dest);
    let params = parameters;
    console.info("POST request with body: " + params);


    Vue.axios
      .post(path, params)
      .then((response) => {
        console.log("Success response from " + path);
        console.log("Status code: " + response.data.status);
        success(response.data);
      })
      .catch((err) => {
        console.error("Error response from " + path);
        console.error("Status code: " + err);
        error(err);
      })
  }

  sendSMS(telephone, content){

    if((!telephone)||(!content)){
      alert("無效輸入，請重新確認。");
    }

    let veriText = encodeURIComponent(content);
    let phone = "852" + telephone;

    let path = "https://api.accessyou.com/sms/sendsms-utf8-senderid.php?accountno=11033610&pwd=54483878&msg="
    + veriText + "&phone=" + phone +"&size=l&from=BauschLomb";    

    let params = {
      accountno: '11033610',
      pwd:'54483878',
      msg: veriText,
      phone: phone,
      size: "l",
      from:'BauschLomb'
    }
     Vue.axios
      .get(path, params)
      .then((response) => {
        // console.log("Success response from " + path);
        // console.log("Status code: " + response.data.status);
        success(response.data);
      })
      // .catch((err) => {
      //   // console.error("Error response from " + path);
      //   // console.error("Status code: " + err);
      //   error(err);
      // })

  }

}


// put(dest, parameters = {}, success, error, parseType = this.ParseTypeEnum.json) {
//     let headers = {
//         "Authorization": "Bearer " + this.token,
//         "Content-Type": "application/json",
//         "Cache-Control": "no-cache",
//     };

//     let path = this.generatePath(dest);
//     let params = JSON.stringify(parameters);
//     console.info("PUT request with body: " + params);

//     fetch(path, {
//             method: 'PUT',
//             headers: headers,
//             body: params
//         })
//         .then(this.checkStatus)
//         .then((response) => {
//             switch (parseType) {
//                 case this.ParseTypeEnum.json:
//                     return response.json();
//                 case this.ParseTypeEnum.empty:
//                     console.debug(response);
//                     return response.status;

//             }
//         })
//         .then((json) => {
//             console.info("Success response from " + path);
//             console.info(json);
//             success(json);
//         }).catch((err) => {
//             console.error("Error response from " + path);
//             console.error("Status code: " + err);
//             error(err);
//         })
// }

// delete(dest, parameters = {}, success, error, parseType = this.ParseTypeEnum.json) {
//     let headers = {
//         "Authorization": "Bearer " + this.token,
//         "Content-Type": "application/json",
//         "Cache-Control": "no-cache",
//     };

//     let path = this.generatePath(dest);
//     let params = JSON.stringify(parameters);
//     console.info("DELETE request with body: " + params);

//     fetch(path, {
//             method: 'DELETE',
//             headers: headers,
//             body: params
//         })
//         .then(this.checkStatus)
//         .then((response) => {
//             switch (parseType) {
//                 case this.ParseTypeEnum.json:
//                     return response.json();
//                 case this.ParseTypeEnum.empty:
//                     console.debug(response);
//                     return response.status;

//             }
//         })
//         .then((json) => {
//             console.info("Success response from " + path);
//             console.info(json);
//             success(json);
//         }).catch((err) => {
//             console.error("Error response from " + path);
//             console.error("Status code: " + err);
//             error(err);
//         })
// }


// checkStatus(response) {
//     console.log(response);
//     if (response.status >= 200 && response.status < 300) {
//         return response
//     } else {
//         var error = new Error(response.statusText)
//         error.response = response
//         throw error
//     }
// }

// nextPage(url) {
//     let headers = {
//         "Authorization": "Bearer " + this.token
//     };

//     console.info("Next page with: " + url);
//     console.info("GET request with headers: " + headers)

//     fetch(url, {
//             method: 'GET',
//             headers: headers
//         })
//         .then(this.checkStatus)
//         .then((response) => {
//             return response.json();
//         })
//         .then((json) => {
//             console.info("Success response from " + path);
//             console.info(json);
//             success(json);
//         }).catch((err) => {
//             console.error("Error response from " + path);
//             console.error("Status code: " + err);
//             error(err);
//         })
// }



// WEBPACK FOOTER //
// ./src/api/api.js